/**
 * Labstep
 *
 * @module SignatureRequest/Form/Create
 * @desc SignatureRequest Create Form
 */

import {
  fieldSignatureRequestMessage,
  fieldSignatureRequestUser,
} from 'labstep-web/components/SignatureRequest/Form/fields';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import type { IFieldTypeSearchSelectProps } from 'labstep-web/core/Form/Reusable/types';
import type { Group } from 'labstep-web/models/group.model';
import { SignatureRequest } from 'labstep-web/models/signature-request.model';
import type { User } from 'labstep-web/models/user.model';
import type React from 'react';
import type { ISignatureRequestFormCreateProps } from './types';

export const getDefaultSignatureRequestMessage = (
  authenticatedUserEntity: User,
  group?: Group | null,
): string => {
  return (
    group?.default_signature_request_message ||
    `Hi

Please review this experiment for me.

Thanks,

${authenticatedUserEntity.name}
`
  );
};

export const SignatureRequestFormCreate: React.FC<
  ISignatureRequestFormCreateProps
> = ({
  experimentWorkflow,
  options,
  authenticatedUserEntity,
  activeGroup,
}) => (
  <FormCreate
    autoFocus
    fields={[
      {
        ...fieldSignatureRequestUser,
        elementProps: {
          ...fieldSignatureRequestUser.elementProps,
          params: { group_id: activeGroup?.id },
        },
      } as IFieldTypeSearchSelectProps,
      fieldSignatureRequestMessage,
    ]}
    defaultValues={{
      [fieldSignatureRequestMessage.name]:
        getDefaultSignatureRequestMessage(
          authenticatedUserEntity,
          activeGroup,
        ),
    }}
    entityName={SignatureRequest.entityName}
    parentName={experimentWorkflow.entityName}
    parentId={experimentWorkflow.id}
    options={options}
    submitButtonText="Request"
  />
);

export default withAuthenticatedUserEntity(
  withActiveGroup(SignatureRequestFormCreate),
);
